<script setup lang="ts">
import { useLandingTheme } from '~/composables/use-landing-theme'
import LandingCateringNav from '~/components/landing/catering/LandingCateringNav.vue'

const { landingThemeVars } = useLandingTheme()
</script>

<template>
  <div
    class="guest-app-bar"
    :style="landingThemeVars"
  >
    <LandingCateringNav />

    <div
      aria-hidden="true"
      class="guest-app-bar__spacer"
    />
  </div>
</template>

<style scoped>
.guest-app-bar :deep(.v-btn) {
  text-transform: none !important;
  letter-spacing: 0 !important;
}

.guest-app-bar :deep(.landing-btn) {
  border-radius: 12px !important;
  font-weight: 600 !important;
  transition: transform 0.2s, box-shadow 0.2s !important;
}

.guest-app-bar :deep(.landing-btn--primary:hover) {
  transform: translateY(-1px);
}

.guest-app-bar__spacer {
  height: 72px;
}
</style>
